import { useStores } from './useStores'
import { CopyrightAuthStatus } from '~/graphqls/types'

export const useAuth = () => {
  const { store } = useStores()
  const isLogin = !!store.token
  const isCreator = store.userinfo?.userRoleInfo?.artist
  const isAiCreator = store.userinfo?.userRoleInfo?.aiArtist
  const isPlazaWhiteListUser = store.userinfo?.isPlazaWhiteListUser

  const isRealName = store.userinfo?.authStatus === CopyrightAuthStatus.AUTH

  const isVip = !!store.userinfo?.isVip
  const isHighUser = !!store.userinfo?.isHighUser

  return {
    /** 是否已登录 */
    isLogin,
    /** 是否已成为普通创作者  */
    isCreator,
    /** 是否已成为AI创作者  */
    isAiCreator,
    /** 是否是广场白名单用户 */
    isPlazaWhiteListUser,
    /** 是否已实名认证 */
    isRealName,
    /** VIP会员 */
    isVip,
    /** VIP会员或白名单 */
    isHighUser,
  }
}
